import React, { useEffect, useState } from "react";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import {
  Box,
  Grid,
  // Typography,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  // Button,
  TextField,
} from "@mui/material";
import { Formik, Form } from "formik";
import { addIndexSchema } from "../../StaticData";
import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import { useSelector } from "react-redux";
// import DySplitButton from "../../../../components/GlobalComponents/DySplitButton/DySplitButton";
// import AccordionLyt from "../../../../components/Layouts/AccordionLyt/AccordionLyt";
import { addIndexFace } from "../../Interfaces/Interfaces";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
// import MultiSel from "../../../../components/MultiSel/MultiSel";
// import VerticalAlignments from "../../new/verticalAlignments";
// import { ArrowDropDownIcon } from "@mui/x-date-pickers";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useAddIndex ,useGetAllCategoriesTenantId} from "../../Hooks/Index";
// import { addIndex} from "../../Api/Index";
// import CustomeMultiSelect from "../../new/customeMultiSelect";
import { ErrorMessage } from "formik";
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
// interface teamIdsFace {
//   teamId: string;
//   personIds: string[];
// }
// allIds

const AddIndex = ({
  onSuccess,
  setShowToastMessage,
  setShowToastMessage2,
  setObjectiveAsyncOpState,
  afterSuccess,
  access,
  onClose
}: any) => {
  const tenantId: string = useSelector((state: any) => state.meetings.profileTenantId);
  const{data} : any = access  || {};
  const{check} : any = data  || {};
  // const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  // const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);
  // const [periodId, setLocalPeriosId] = useState<string>(periodId);
  // const [showVerticalAlignment, setShowVerticalAlignment] =useState<boolean>(false);
  // const [showMultiSelect, setShowMultiSelect] = useState<boolean>(false);
  // const [objNameIds, setObjNameIds] = useState<any>({
  //   tenantId: tenantId,
  //   // periodId: periodId,
  //   definitionLevelId: null,
  // });

  // const { data: teamsOptions, isLoading: teamOPloading } =
  //   useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
  const { data: categoriesOptionds ,isLoading:getActivePersonLoading} = useGetAllCategoriesTenantId(tenantId);
  const {
    mutate: addObjective,
    data: addObjectiveData,
    // isSuccess,
    // isLoading,
    // isError: isErrorInAddObjective,
  } = useAddIndex();

  //AMIR const periodId = useSelector((state: any) => state.meetings.priodId);
  // const [verticalAlignmentBaseData, setVerticalAlignmentBaseData] =
    // useState<any>([]);

  // const [periodOptions, setPeriodOptions] = useState<any>([]);
  // const [horzinalAliIds, setHorzinalAliIds] = useState<any[]>([]);
  const [allIds, setAllIds] = useState<any>([]);
  // const [okrStateId, setOkrStateId] = useState<string>("");
  const [lIsPublic, setlIsPublic] = useState<any>(false);
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [addObjError, setAddObjError] = useState<any>(null);
  // const [isSubmittingForm, setIsSubmittingForm] = useState<boolean>(false);
  const[personIdData,setPersonIdData]=useState([])
  const[personIdData1,setPersonIdData1]=useState<any>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [teamName, setTeamName] = useState<any>({
  //   teamName: null,
  // });

  const [allTeamAndPersonBaseData, setAllTeamAndPersonBaseData] = useState<any>(
    []
  );

  const showNameConditionData = [
    { key: "نام ایجاد کننده و شاخص به نام شرکت ما منتشر شود", value: "CreatorAndCompany" },
    { key: "تنها شاخص به نام شرکت ما منتشر شود", value: "Company" },
    { key: "شاخص بصورت ناشناس منتشر شود", value: "None" },
  ];
  // const { data: allTeamAndPersonData }: any =
  //   useGetAllTeamAndPersonNameByTenantId(tenantId);

  // const onSuccessInAddObjective = () => {
  //   afterSuccess();
  //    onSuccess((prev:any)=>!prev)
  // };

  // const onErrorInAddObjective = (data: string) => {
  //   const Err = { isSuccess: false, metaData: { message: data.toString() } };
  //   setAddObjError(Err);
  //   setShowLtoastMessage(true);
  // };
  useEffect(() => {
    if (categoriesOptionds) {
      setPersonIdData1(categoriesOptionds);
    }
  }, [categoriesOptionds]);

  useEffect(() => {
    if(personIdData1 !== null && personIdData1 !== undefined ){
      setPersonIdData(personIdData1?.data?.map((item:any)=>{
        let{name,id}=item;
        return {year:id,title:name}
      }))
    }
  }, [personIdData1]);


  useEffect(() => {
    if (addObjectiveData) {
      setIsSubmitting(false);
      if (addObjectiveData?.data.isSuccess) {
        // setSuccessAddObjective(isSuccess)
        setShowToastMessage2(true);
        SetIsSuccess(true);
        SetTMessage(addObjectiveData?.data.metaData.message);
        onSuccess();
        onClose(false);
      } else {
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addObjectiveData?.data.metaData.message);
        setAddObjError(addObjectiveData?.data);
      }
    }
  }, [addObjectiveData]);

  const addObjectiveInitialValues: addIndexFace = {
    name: "",
    // createById:'',
    description: "",
    indexType2: "lag",
    periodType: "Retrospect",
    indexType1: "KPI",
    AddToMyList : true,
    IsBAU : true,
    IsKR : true,
    AddToTenantList : true,
    fromTenantId:tenantId
    // isPublic: true,
    // keyResultParentIds: [],
    // responsibleId: "",
    // allIds: [],
    // tenantId: "",
    // weight: null,
    // answerRequest: "",
  };

  const initialAddObjective = async (data: any) => {
    // let { addTe } = data;
    // check === false ? 
    setIsSubmitting(true);
   await addObjective(data);
  };

  // const initialAddObjective = (data: any) => {
  //   addObjective({...data,tenantId:tenantId})
  //   console.log(data)
  // }



  // useEffect(() => {
  //   let transformed = periodsData?.map((item: any) => {
  //     let { name: key, id: value } = item;
  //     return { key, value };
  //   });
  //   setPeriodOptions(transformed);
  // }, []);

  // useEffect(() => {
  //   if (ObjectiveNameOptions) {
  //     const localVerticalAlignmentBaseData = ObjectiveNameOptions.map(
  //       (group: any) => ({
  //         ...group,
  //         items: group.items.map((item: any) => ({ ...item, checked: false })),
  //       })
  //     );

  //     setVerticalAlignmentBaseData(localVerticalAlignmentBaseData);
  //   }
  //   if (allTeamAndPersonData) {
  //     const localAllTeamAndPersonBaseData = allTeamAndPersonData.map(
  //       (item: any) =>
  //         allIds && allIds.findIndex((vItem: any) => vItem.id === item.id) > -1
  //           ? { ...item, checked: true }
  //           : { ...item, checked: false }
  //     );

  //     setAllTeamAndPersonBaseData(localAllTeamAndPersonBaseData);
  //   }
  // }, [ObjectiveNameOptions]);

  // if (isLoading) {
  //   return <Box width={'100%'} py={6} textAlign={'center'}   >
  //       <CircularProgress/>
  //   </Box>
  // }

  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        <Formik
          enableReinitialize
          validationSchema={addIndexSchema}
          validate={(data) => {
            let { definitionLevelId, responsibleId, isPublic }: any = data;
            // console.log(isPublic)
            setlIsPublic(isPublic);
            if (isPublic === "برای همه") {
              setAllIds([]);
            }
            // setTeameIdObjects((prev:teamIdsFace)=>({...prev,personIds:[responsibleId]}))
            // setHorzIds((prev:any)=>({...prev,definitionId:definitionLevelId}))
            // console.log(data)
          }}
          initialValues={{ ...addObjectiveInitialValues }}
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container padding={2}>
                <Grid item xs={12} md={12}>
                <div className='error'>
            <ErrorMessage  name="name" />
                </div>
                  <FormikControl
                    control="textField"
                    type="text"
                    label="شرح"
                    name="name"
                    fullWidth
                    values={values?.name || ""}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <FormikControl
                    control="textField"
                    type="text"
                    label="فرمول"
                    name="formula"
                    fullWidth
                    values={values?.formula || ""}
                  />
                </Grid>

                <Grid item xs={12} md={12} >
                  <div className='error'>
                  <ErrorMessage name="categoryIds" />
                  </div>
                  <MultiSelect
                    options={personIdData || []}
                    isLoading={getActivePersonLoading}
                    onChangee={setFieldValue}
                    propName='categoryIds'
                    label="دسته بندی"
                  />
              </Grid>        
                    <Grid item xs={12} md={12} >
                    <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">
                    <span className="items-center">نوع استفاده:</span>
                      <label className="flex gap-x-2 items-center w-1/6">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="IsBAU"
                            value="IsBAU"
                            id="IsBAU"
                            defaultChecked = {true}
                            onChange={() =>
                              values?.IsBAU ===
                              true ? setFieldValue(
                                "IsBAU",
                                false
                              ) : 
                              setFieldValue(
                                "IsBAU",
                                true
                              )
                            }
                            checked={
                              values?.IsBAU ===
                              true
                            }
                          />
                          <span className="text-xs">
                            پایش(BAU)
                          </span>
                      </label>
                      <label className="flex gap-x-2 w-1/6 items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="IsKR"
                            value="IsKR"
                            id="IsKR"
                            defaultChecked={true}
                            onChange={() =>
                              values?.IsKR === 
                              true?
                              setFieldValue(
                                "IsKR",
                                false
                              ):
                              setFieldValue(
                                "IsKR",
                                true
                              )
                            }
                            checked={
                              values?.IsKR === 
                              true
                            }
                          />
                          <span className="text-xs">بهبود(KR)</span>
                        </label>
                      </div>
                    </Grid>

                    <Grid item xs={12} md={12} >
                    <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">

                    <span className="items-center"> بازه زمانی:</span>
                        <label className="flex gap-x-2 w-1/6 items-center mr-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="Retrospect"
                            value="Retrospect"
                            id="Retrospect"
                            onChange={() =>
                              setFieldValue(
                                "periodType",
                                "Retrospect"
                              )
                            }
                            checked={
                              values?.periodType === "Retrospect"
                            }
                          />
                          <span className=" text-xs">گذشته نگر</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-1/6">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="Present"
                            value="Present"
                            id="Present"
                            onChange={() =>
                              setFieldValue(
                                "periodType",
                                "Present"
                              )
                            }
                            checked={
                              values?.periodType ===
                              "Present"
                            }
                          />
                          <span className=" text-xs">
                           زمان حال
                          </span>
                        </label>
                        <label className="flex gap-x-2 items-center w-2/6">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="futuristic"
                            value="futuristic"
                            id="futuristic"
                            onChange={() =>
                              setFieldValue(
                                "periodType",
                                "futuristic"
                              )
                            }
                            checked={
                              values?.periodType ===
                              "futuristic"
                            }
                          />
                          <span className=" text-xs">
                          آینده نگر
                          </span>
                        </label>
                      </div>
                      </Grid>

                    <Grid item xs={12} md={12} >
                    <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">

                    <span className="items-center">نوع:</span>
                      {/* <div className="h-11 w-full flex  items-center"> */}
                        <label className="flex gap-x-2 items-center mr-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="KPI"
                            value="KPI"
                            id="KPI"
                            onChange={() =>
                              setFieldValue(
                                "indexType1",
                                "KPI"
                              )
                            }
                            checked={
                              values?.indexType1 === "KPI"
                            }
                          />
                          <span className=" text-xs">شاخص کلیدی عملکرد(KPI)</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-1/6 mr-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="PI"
                            value="PI"
                            id="PI"
                            onChange={() =>
                              setFieldValue(
                                "indexType1",
                                "PI"
                              )
                            }
                            checked={
                              values?.indexType1 ===
                              "PI"
                            }
                          />
                          <span className=" text-xs">
                           شاخص عملکرد(PI)
                          </span>
                        </label>
                        <label className="flex gap-x-2 items-center w-1/6">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="RI"
                            value="RI"
                            id="RI"
                            onChange={() =>
                              setFieldValue(
                                "indexType1",
                                "RI"
                              )
                            }
                            checked={
                              values?.indexType1 ===
                              "RI"
                            }
                          />
                          <span className=" text-xs">
                          شاخص نتیجه(RI)
                          </span>
                        </label>
                        <label className="flex gap-x-2 items-center">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="KRI"
                            value="KRI"
                            id="KRI"
                            onChange={() =>
                              setFieldValue(
                                "indexType1",
                                "KRI"
                              )
                            }
                            checked={
                              values?.indexType1 ===
                              "KRI"
                            }
                          />
                          <span className=" text-xs">
                          شاخص کلیدی نتیجه(KRI)
                          </span>
                        </label>
                      </div>
                      </Grid>

                      <Grid item xs={12} md={12} >
                      <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">

                      <span className="items-center">نوع شاخص:</span>
                      {/* <div className="h-11 w-full flex  items-center"> */}
                        <label className="flex gap-x-2 w-1/6 items-center mr-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="lag"
                            value="lag"
                            id="lag"
                            onChange={() =>
                              setFieldValue(
                                "indexType2",
                                "lag"
                              )
                            }
                            checked={
                              values?.indexType2 === "lag"
                            }
                          />
                          <span className=" text-xs">پسرو</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-1/6">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="lead"
                            value="lead"
                            id="lead"
                            onChange={() =>
                              setFieldValue(
                                "indexType2",
                                "lead"
                              )
                            }
                            checked={
                              values?.indexType2 ===
                              "lead"
                            }
                          />
                          <span className=" text-xs">
                            پیشرو
                          </span>
                        </label>
                      </div>
                      </Grid>

                      <Grid item xs={12} md={12} >
                      <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">

                      <span className= " items-center">نوع انتشار:</span>
                      {/* <div className="h-11 w-full flex gap-x-8 items-center"> */}
                        <label className="flex gap-x-2 w-1/6 items-center mr-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="forAll"
                            value="forAll"
                            id="forAll"
                            onChange={() => setFieldValue("isPublic", true)}
                            checked={values?.isPublic}
                          />
                          <span className=" text-xs">عمومی</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-1/6">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="forCertain"
                            value="forCertain"
                            id="forCertain"
                            onChange={() => setFieldValue("isPublic", false)}
                            checked={!values?.isPublic}
                          />
                          <span className=" text-xs">
                            اختصاصی شرکت
                          </span>
                        </label>
                        <div className="w-3/6">
                          {values?.isPublic && allTeamAndPersonBaseData && (
                            <div className=" relative cursor-pointer ">
                              
                              {/* <div
                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                  e.preventDefault();
                                  setShowMultiSelect(!showMultiSelect);
                                }}
                                className={` px-2 w-[98%] py-2 mt-1 flex justify-between text-xs font-thin text-black 
                               
                                 rounded-md  ml-3 border-2 ${
                                   showMultiSelect
                                     ? "border-sky-600"
                                     : "border-slate-200"
                                 }   `}
                              >
                                برای اشخاص و تیم های خاص
                                {showMultiSelect ? (
                                  <ArrowDropUpIcon />
                                ) : (
                                  <ArrowDropDownIcon />
                                )}
                              </div> */}
                              <Grid item xs={12} md={12}>
                              <FormikControl
                                control="select"
                                type="select"
                                label="نحوه انتشار "
                                options={showNameConditionData}
                                name="publishType"
                                fullWidth
                              />
                            </Grid>
                            </div>

                            //  <CustomeMultiSelect
                            //       data={allTeamAndPersonData}
                            //       setCheckBoxes={() => {}}
                            //       setShowMultiSelect={setshowMultiSelect}
                            //       title=" تنظیمات پیشرفته ( اختیاری)"
                            //     />

                            // <MultiSel
                            //   data={allTeamAndPersonData || []}
                            //   extractTag={setAllIds}
                            //   label={"برای اشخاص و تیم های خاص"}
                            // />
                          )}
                        </div>
                      </div>
                      </Grid>

                    <Grid container>

                      <Grid item xs={12} md={12}>
                        <Box sx={{ padding: "8px" }}>
                          <TextField
                            size="small"
                            label="توضیحات"
                            name="description"
                            fullWidth
                            value={values?.description}
                            onChange={({ target }: any) => {
                              let { value } = target;
                              setFieldValue("description", value);
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={12}>
                      <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">
                      {/* <div className="h-11 w-full flex  items-center"> */}
                        <label className="flex gap-x-1 w-2/6 items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="AddToMyList"
                            value="AddToMyList"
                            id="AddToMyList"
                            defaultChecked={true}
                            onChange={() =>
                              values?.AddToMyList === 
                              true?
                              setFieldValue(
                                "AddToMyList",
                                false
                              ):
                              setFieldValue(
                                "AddToMyList",
                                true
                              )
                            }
                            checked={
                              values?.AddToMyList === 
                              true
                            }
                          />
                          <span className="text-md-xs font-weight[600]">به لیست من اضافه شود</span>
                        </label>
                      </div>
                      </Grid>
                      
                      <Grid item xs={12} md={12}>
                      <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">
                      {
                      check && ( <label className="flex gap-x-1 items-center w-2/6">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="AddToTenantList"
                            value="AddToTenantList"
                            id="AddToTenantList"
                            defaultChecked = {true}
                            onChange={() =>
                              values?.AddToTenantList ===
                              true ? setFieldValue(
                                "AddToTenantList",
                                false
                              ) : 
                              setFieldValue(
                                "AddToTenantList",
                                true
                              )
                            }
                            checked={
                              values?.AddToTenantList ===
                              true
                            }
                          />
                          <span className="text-md-xs ">
                            به لیست شرکت اضافه شود
                          </span>
                      </label>)}
                      </div>
                      </Grid>
                    </Grid>
                  {/* </AccordionLyt> */}
                {/* </div> */}

                <Grid item xs={12} md={12} mt={1}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                    {/* {submitOptions &&
                      submitOptions?.map((item: any, i: number) => {
                        let { label, id } = item;
                        // console.log(item)
                        return (
                          <Box width={"20%"}>
                            <DyButton
                              disabled={!dirty || !isValid || isSubmittingForm}
                              key={i}
                              type={"submit"}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={label}
                              onClick={() => {
                                setOkrStateId(id);
                              }}
                            />
                          </Box>
                        );
                      })} */}
                      <Box width={"20%"}>
                            <DyButton
                              // disabled={false}
                              disabled={isSubmitting}
                              // key={i}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={'ثبت'}
                              type={"submit"}
                              onClick={() => { }}
                            />
                          </Box>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Box>
    </>
  );
};

export default AddIndex;